export default __webpack_public_path__ + "static/media/Minicard_3d.4871d089.svg";